// extracted by mini-css-extract-plugin
var _1 = "styles-module__bottomPositioning___CyEWf";
var _2 = "styles-module__button___g5W3q";
var _3 = "styles-module__reportButton___PMA45";
var _4 = "styles-module__reportContainer___xBXI8";
var _5 = "styles-module__staticCta___gd70a";
var _6 = "styles-module__subtext___NIYjS";
var _7 = "styles-module__title___Rss3B";
export { _1 as "bottomPositioning", _2 as "button", _3 as "reportButton", _4 as "reportContainer", _5 as "staticCta", _6 as "subtext", _7 as "title" }
